export enum Roles {
  administrator = "administrator",
  agency = "agency",
  auditor = "auditor",
  operator = "operator",
  agency_v2 = "agency_v2",
}
